import { RouterProvider } from 'react-router-dom';
import { useState, useCallback, useEffect } from 'react';

import router from './routes/Router';
import AuthProvider from './context/AuthContext';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default App;
